export default __webpack_public_path__ + "static/media/daxa-title.55ab22bd.svg";